module.exports = __webpack_public_path__ + "static/pocket-pills-fr-1481a57c7b1cd56482c87f3386d5d411.png";